import { createStore, combineReducers } from "redux";
import reducer from "./reducers/timelineReducer";
import todoListReducer from "./reducers/todoListReducer";
import pollListReducer from "./reducers/pollListReducer";
import allTeamReducer from "./reducers/allTeamReducer";
import wallOfFameReducer from "./reducers/wallOfFameReducer";
import companyReducer from "./reducers/companyReducer"
import courseReducer from "./reducers/courseReducer";
import myCoursesReducer from "./reducers/myCoursesReducer";

const rootReducer = combineReducers({
  timelineReducer: reducer,
  todoListReducer: todoListReducer,
  pollListReducer: pollListReducer,
  teamsReducer: allTeamReducer,
  wallOfFameReducer: wallOfFameReducer,
  companyReducer: companyReducer,
  courseReducer: courseReducer,
  myCoursesReducer: myCoursesReducer,
});

export const reduxStore = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
